angular.module 'zc.commonApi'

.factory 'CampaignPolicySet', ($resource, $q, Api) ->
  URL = '/api/projects/:projectId/campaign_policy_sets/:id'
  CampaignPolicySet = $resource Api.path(URL), { projectId: @projectId, id: @id },
    query:
      method: 'GET'
      isArray: false # Rails returns object instead of array
    save:
      method: 'POST'
      headers:
        'Content-Type': undefined
      transformRequest: (data) ->
        formData = new FormData()
        angular.forEach data, (val, key) ->
          formData.append key, val
        formData
    destroy:
      method: 'DELETE'

  service =
    all: (params) ->
      $q (resolve, reject) ->
        CampaignPolicySet.query params, (res) ->
          resolve res.campaign_policy_sets

    create: (params, set) ->
      $q (resolve, reject) ->
        campaign_policy_set = new CampaignPolicySet set
        campaign_policy_set.$save(params)
        .then (res) ->
          resolve res.campaign_policy_set

    destroy: (params) ->
      $q (resolve, reject) ->
        CampaignPolicySet.destroy params
        .$promise.then (res) ->
          resolve res

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/campaign_policy_set.service.coffee